var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1982 19.8572C21.9962 20.208 21.7046 20.4986 21.3532 20.6995C21.0018 20.9003 20.6033 21.004 20.1985 21.0001H3.80167C3.39695 21.004 2.99846 20.9003 2.64706 20.6995C2.29566 20.4986 2.004 20.208 1.80198 19.8572C1.60486 19.5199 1.50098 19.1361 1.50098 18.7454C1.50098 18.3546 1.60486 17.9709 1.80198 17.6335L9.99854 3.39569C10.2034 3.04687 10.4959 2.75764 10.847 2.55668C11.1981 2.35572 11.5956 2.25 12.0001 2.25C12.4046 2.25 12.8022 2.35572 13.1532 2.55668C13.5043 2.75764 13.7968 3.04687 14.0017 3.39569L22.2001 17.6335C22.3969 17.9711 22.5005 18.3549 22.5002 18.7456C22.4998 19.1364 22.3956 19.52 22.1982 19.8572Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/Icon.efad6ce4435844feb85e9f8201a172c2.svg";
export { ForwardRef as ReactComponent };